
import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Alert } from "../../addons/Alert";
//import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import router from "../../router";
import FormResina from "./Form.vue"
import nuevaResina from "./Nuevo.vue";

@Component({
  name: "ResinasIndex",
  components: { FormResina, nuevaResina }
})
export default class ResinasIndex extends Vue {

  private globalStore = globalStore();
  private consultorioStore = useConsultorioStore();
  private consultorioService = consultorioService.getInstance();
  private tab: any = null;
  public dialog = false;
  fecha = DateTime.now().toFormat('yyyy-MM-dd');
  public swForm = false;
  swNuevo = false;
  resina_selected = {};
  esmaltes = []
  dentinas = []
  translucidas = []
  opacos = []
  nombreSelected = "";
  get resinas(): any {
    return this.consultorioStore.resinas;
  }

  public txtSearch = "";
  swEditar = false
  mounted() {
    this.getResinas();
  }
  getResinas() {
    this.consultorioService.getResinas()
  }

  get resinasFilter(): any {
    let data = this.resinas;
    if (this.txtSearch != '') {
      return data.filter(val => val.nombre.toUpperCase().includes(this.txtSearch.toUpperCase()))
    }
    return data;
  }
  nuevaResina() {
    this.swNuevo = true;
    this.swEditar = false;

  }
  editar(resina: any) {
    this.swForm = true;
    this.swEditar = true;
    this.resina_selected = resina
    this.seleccionar(resina)
  }
  detalle(resina: any) {
    this.nombreSelected = resina.resina;
    this.seleccionar(resina)
  }
  seleccionar(resina:any) {
    this.esmaltes = resina.componentes.filter(val => val.tipo == 'ESMALTE')
    this.dentinas = resina.componentes.filter(val => val.tipo == 'DENTINA')
    this.translucidas = resina.componentes.filter(val => val.tipo == 'ZONA TRANSLUCIDA')
    this.opacos = resina.componentes.filter(val => val.tipo == 'OPACO')
  }

  close() {
    this.swForm = false;
  }

  get pagination(): any {
    return this.consultorioStore.pagination;
  }
  get loading(): boolean {
    return this.consultorioStore.loading;
  }

}
